module.exports = __webpack_public_path__ + "img/banner2_left.ca3fd080.jpg";